import { UserPhotoCard } from './userPhotoCard'

export { UserPhotoCard }
